import { render, staticRenderFns } from "./PassWordSet.vue?vue&type=template&id=0a68c260&scoped=true"
import script from "./PassWordSet.vue?vue&type=script&lang=js"
export * from "./PassWordSet.vue?vue&type=script&lang=js"
import style0 from "./PassWordSet.vue?vue&type=style&index=0&id=0a68c260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68c260",
  null
  
)

export default component.exports